module.exports = __webpack_public_path__ + "img/chefstein.83e649e2.png";